import { render, staticRenderFns } from "./StdSizeExtends.vue?vue&type=template&id=ae8ea96c&scoped=true"
import script from "./StdSizeExtends.vue?vue&type=script&lang=js"
export * from "./StdSizeExtends.vue?vue&type=script&lang=js"
import style0 from "./StdSizeExtends.vue?vue&type=style&index=0&id=ae8ea96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8ea96c",
  null
  
)

export default component.exports